// src/i18n/LanguageProvider.tsx

import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import {
  createI18n,
  createI18nAsync,
  type AppLang,
  type I18nConstants,
} from './locales/i18n.factory';

type ContextType = {
  lang: AppLang;
  setLang: (l: AppLang) => void;
  toggleLang: () => void;   // ⭐️ חדש
  i18n: I18nConstants;
};

const I18nContext = createContext<ContextType | null>(null);

export const LanguageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [lang, setLang] = useState<AppLang>('he');
  const [i18n, setI18n] = useState<I18nConstants>(() => createI18n('he'));

  const toggleLang = () =>
    setLang((prev) => {
      if (prev === 'he') return 'en';
      if (prev === 'en') return 'ru';
      if (prev === 'ru') return 'fr';
      return 'he';
    });
  useEffect(() => {
    let cancelled = false;

    createI18nAsync(lang).then((nextI18n) => {
      if (!cancelled) setI18n(nextI18n);
    });

    return () => {
      cancelled = true;
    };
  }, [lang]);

  // ⭐️⭐️⭐️ שינוי כיוון האתר כולו
  useEffect(() => {
    const isRTL = lang === 'he';

    const html = document.documentElement;

    html.lang = lang;
    html.dir = isRTL ? 'rtl' : 'ltr';

    // optional — class helpers
    html.classList.toggle('rtl', isRTL);
    html.classList.toggle('ltr', !isRTL);

  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, toggleLang, i18n }),
    [lang, i18n]
  );

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = (): ContextType => {
  const ctx = useContext(I18nContext);

  if (!ctx) {
    throw new Error(
      'useI18n must be used inside LanguageProvider'
    );
  }

  return ctx;
};
